import { createSelector } from 'reselect';

import { selectUnderwriting } from './underwriting.selectors';

export const selectCalculators = createSelector(selectUnderwriting, ({ calculators }) =>
  Object.values(calculators),
);
